module.exports = __webpack_public_path__ + "img/jiudianbao.37c3c0d0.jpg";